export default {
    index: {
        listagem_conversao_resultado: 'Lista de Conversión de resultados',
        conversao_resultado_nao_encontrada: 'No se encontraron conversiones de resultados',
        criar_conversao_resultado: 'Crear Conversión de Resultados',
        origem: 'Origen',
        destino: 'Destino',
        exame: 'Examen',
        editar: 'Editar'
    },
    form: {
        integracao_origem: 'Integración de Origen',
        integracao_destino: 'Integración de Destino',
        exame: 'Examen',
        operacao: 'Operación',
        operacao_descricao: 'Operación que se aplicará al resultado. Ejemplos: + 10 o - 10 o * 10 o / 10',
        status_descricao: 'Estado de conversión de resultados',
        titulo_editar: 'Editar Resultado de Conversión',
        titulo_criar: 'Crear Nueva Conversión de Resultados',
        integracao_origem_obrigatoria: '¡La selección de integración de fuente es obligatoria!',
        integracao_destino_obrigatoria: '¡La selección de integración de destino es obligatoria!',
        exame_obrigatorio: '¡La selección del examen es obligatoria!',
        regra_operacao_obrigatoria: 'En el campo de operación, solo se permiten números, comas y operadores matemáticos básicos.',
        criada_sucesso: 'Configuración de conversión de resultados creada con éxito',
        editada_sucesso: 'Configuración de conversión de resultados actualizada con éxito'
    }
}